import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { DxPopupComponent } from 'devextreme-angular';
import { ClientService } from 'src/app/services/client.service';
import { SessionContextService } from 'src/app/services/session-context.service';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true})
@Component({
  selector: 'app-client-photo',
  templateUrl: './client-photo.component.html',
  styleUrls: ['./client-photo.component.css']
})
export class ClientPhotoComponent implements OnInit, OnDestroy {

  title:string="Client Photo via WebCam";

  @Output() public pictureTaken = new EventEmitter<WebcamImage>();

  // Please note that once a webcam picture or file upload has been started, the image is saved to client record. This cannot be undone.

  // toggle webcam on/off - Please note that the webcam code does work, but UI does not indicate that picture has been taken.   
  public showWebcam = true;

  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };
  public errors: WebcamInitError[] = [];
  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  @Output() CloseDlg: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;

  OkButtonOptions = {
    text: 'OK',
    onClick: this.btnOk.bind(this)
  };

  CancelButtonOptions = {
    text: 'Cancel',
    onClick: this.btnCancel.bind(this),
  };

  imageSource = '';
  isLoadIndicatorVisible:boolean=true;

  constructor(private clientService:ClientService, private session:SessionContextService, private changeDetectorRef: ChangeDetectorRef) { 
  }

  ngOnInit(): void {
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        this.isLoadIndicatorVisible=false;
        this.changeDetectorRef.detectChanges();
      });          
  }

  ngOnDestroy(): void {
    this.trigger?.unsubscribe();
    this.nextWebcam?.unsubscribe();
  }

  public show() {    
    this.popup.visible = true;
  }

  btnOk(e) {
    this.CloseDlg.emit(this.imageSource);
    this.popup.visible = false;
  }


  btnCancel(e) {
    this.CloseDlg.emit("");
    this.popup.visible = false;
  }

  //
  // Web Cam Code from here on .
  //
  TakePictureButtonOptions =
  {
    text: 'Ok',
    onClick: this.triggerSnapshot.bind(this),
  }

  SwapCamButtonOptions =
  {
    text: 'Swap',
    onClick: this.showNextWebcam.bind(this),
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
    if (error.mediaStreamError && error.mediaStreamError.name === "NotAllowedError") {
      console.warn("Camera access was not allowed by user!");
    }
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.info('received webcam image', webcamImage);            
    this.imageSource=webcamImage.imageAsDataUrl;
    this.pictureTaken.emit(webcamImage);
    
    this.popup.visible=false;
    this.CloseDlg.emit(this.imageSource);    
  }

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

}
